import { useStaticQuery, graphql } from "gatsby";


const UseShortFormQuery = () => {
    const { kontentItemShortFormLegal } = useStaticQuery(graphql`
            query  {
                kontentItemShortFormLegal {
                    elements {
                        legal {
                            value
                            name
                        }
                    }
                }
            }
    `);

    return kontentItemShortFormLegal.elements;
}

export default UseShortFormQuery;